import { render, staticRenderFns } from "./chart-sankey.vue?vue&type=template&id=98fdb09e&"
import script from "./chart-sankey.vue?vue&type=script&lang=ts&"
export * from "./chart-sankey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports